<template>
  <v-row>

    <DialogDashboards :dialog="dialog"/>
    <v-dialog v-model="dialog2.status" max-width="575" persistent>
      <v-card class="pa-5">
        <v-card-title class="text-h4">
          <span class="mx-auto">{{ dialog2.title }}</span>
        </v-card-title>
        <div class="text-center py-3">
          <v-icon size="100" :color="dialog2.iconColor">{{ dialog2.icon }}</v-icon>
        </div>
        <v-card-text class="text-h6 text-center">{{ dialog2.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" elevation="0" class="px-10" @click="dialog2.status = false, get()">OK</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Verificação de titulos a serem baixados-->
    <v-dialog v-model="dialogVerifica" scrollable>
      <v-card class="primary">
        <v-card-subtitle class="white--text text-center pt-6 pb-4 pl-4 pr-3 ">

          <span class="text-h6">TÍTULOS A SEREM BAIXADOS</span>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="px-3 pb-0">
          <v-alert v-if="clientesComPendencia.length > 0" type="warning" dense class="mt-3 mb-2 text-body-2">
            Cheques ainda não devolvidos pela filial não serão baixados:
            {{ clientesComPendencia.map(c => `${c.cliente} (${c.quantidade})`).join(', ') }}
          </v-alert>
          <v-simple-table fixed-header height="50vh" widht="80vh" class="table">
            <template v-slot:default>
              <thead class="header">
              <tr>
                <th>Cliente</th>
                <th>Título</th>
                <th class="pr-0">Digito Titulo</th>
                <th class="pr-0">Saldo Título</th>
                <th class="pr-0">Juros Mora</th>
                <th class="pr-0">Valor Atualizado</th>
                <th class="pr-0">Tipo</th>
              </tr>
              </thead>
              <tbody class="body text-capitalize" v-if="titulosSelecionados.length > 0">
              <tr v-for="(d, i) in titulosSelecionados" :key="i">
                <td class="pr-0" nowrap>{{ d.cliente }}</td>
                <td class="pr-0" nowrap>{{ d.titulo }}</td>
                <td class="pr-0" nowrap>{{ d.digitotitulo }}</td>
                <td class="pr-0">{{ d.saldotitulo | formataDinheiro }}</td>
                <td class="pr-0">{{ d.jurosmora | formataDinheiro }}</td>
                <td class="pr-0">{{ d.valoratualizado | formataDinheiro }}</td>
                <td class="pr-0">{{ d.tipo }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td class="text-center" colspan="7">Nenhum título selecionado.</td>
              </tr>
              </tbody>
              <tfoot class="foot text-capitalize">
              <tr class="cursor-normal">
                <td nowrap class="bold-text">Total a ser baixado:</td>
                <td nowrap></td>
                <td nowrap></td>
                <td nowrap class="bold-text">{{ somar(titulosSelecionados, 'saldotitulo') | formataDinheiro }}</td>
                <td nowrap class="bold-text">{{ somar(titulosSelecionados, 'jurosmora') | formataDinheiro }}</td>
                <td nowrap class="bold-text">{{ somar(titulosSelecionados, 'valoratualizado') | formataDinheiro }}</td>
                <td nowrap class="bold-text"></td>
              </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="pa-1 pb-3 pr-3">
          <v-spacer />
          <v-btn :loading="carregando" class="px-5 white--text" color="red darken-3" elevation="0"
                 @click="dialogVerifica = false">
            Fechar
            <v-icon class="pl-2 pb-1">mdi-close</v-icon>
          </v-btn>
          <v-btn :loading="carregando" class="px-5 white--text" color="green darken-1" elevation="0"
                 :disabled="titulosSelecionados.length <= 0" @click="baixarTitulos()">
            Salvar
            <v-icon class="pl-2 pb-1">mdi-content-save</v-icon>
          </v-btn>

        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-col cols="12">
      <!-- FILTROS -->
      <v-card class="my-2">
        <v-card-title>
          <v-row no-gutters>
            <v-col class="pr-2">
              <v-select :items="datas" item-text="name" item-value="value" label="Período" outlined dense
                        v-model="busca.data" hide-details></v-select>
            </v-col>
            <v-col class="pr-2">
              <v-select :items="filiaisFiltro" item-text="filial" item-value="idfilial" label="Filial"
                        outlined dense v-model="busca.idfiliais" hide-details multiple
                        class="single-line-selection">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.filial }}</span>
                  <span v-if="index === 1" class="grey--text text-caption">
										(+{{ busca.idfiliais.length - 1 }})
									</span>
                </template>

                <template #prepend-item>
                  <v-list-item class="pr-0" dense>
                    <v-list-item-action>
                      <v-checkbox v-model="selectAllChecked"
                                  @click.stop="toggleSelectAll('CHECKBOX')"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content @click="toggleSelectAll('LABEL')">
                      <!-- Use uma tag label para vincular ao checkbox -->
                      <label class="text-subtitle-2">Todas</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>

            <v-col cols="auto" class="pl-2">
              <v-btn :disabled="carregando || busca.idfiliais.length === 0" class="mt-1" color="primary"
                     elevation="0" fab rounded x-small @click="listar(0)">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
      </v-card>

      <v-card class="primary my-4" dark>

        <v-card-subtitle class="white--text font-weight-black text-center">
          <span v-if="!buscou">SELECIONE O PERÍODO E AS FILIAIS E CLIQUE EM BUSCAR</span>
          <span v-else-if="carregando">CARREGANDO SALDO TOTAL DO CREDU A BAIXAR...</span>
          <template v-else>
            <v-icon class="mr-2" size="30">mdi-cash</v-icon>
            <span>SALDO TOTAL DO CREDU A BAIXAR: {{ dados.totalcredu | formataDinheiro }}</span>
          </template>
        </v-card-subtitle>

        <v-divider class="white" />

        <v-card-text class="pa-3 pb-1">

          <v-progress-linear indeterminate absolute :active="carregando" />

          <v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" light />
          <v-data-table v-else :headers="headers" :items="dados.lista" :expanded.sync="expanded"
                        :items-per-page="-1" item-key="compositeKey" class="elevation-0" expand-icon="mdi-menu-down"
                        @click:row="handleRowClick" :item-class="rowClass" mobile-breakpoint="0"
                        v-model="selecionadosAgrupado" hide-default-footer :show-select="false" light>

            <template v-slot:header.data-table-select>
              <v-simple-checkbox :value="selectAll" @input="toggleSelectAllCredu" :indeterminate="isIndeterminate"
                                 :disabled="dadosTodosCliente.lista.length <= 0 || carregando || carregando2" />
            </template>

            <template v-slot:item.data-table-select="{ item }">
              <div @click.stop>
                <v-simple-checkbox :value="isClienteSelecionado(item)" @input="toggleCliente(item)"
                                   :dark="expanded.includes(item)" :color="expanded.includes(item) ? 'white' : undefined"
                                   :disabled="dadosTodosCliente.lista.length <= 0 || carregando || carregando2" />
              </div>
            </template>

            <template v-slot:item.chequespendentes="{ item }">
              <v-tooltip v-if="item.chequespendentes > 0" bottom>
                <template v-slot:activator="{ on }">
                  <v-chip v-on="on" small color="orange darken-2" class="white--text font-weight-bold">
                    {{ item.chequespendentes }} não devolvido{{ item.chequespendentes > 1 ? 's' : '' }}
                  </v-chip>
                </template>
                <span>Cheques ainda não devolvidos pela filial; não serão baixados</span>
              </v-tooltip>
            </template>

            <template v-slot:item.idempresa="{ item }">
              <span class="text-truncate">{{ item.idempresa }}</span>
            </template>

            <template v-slot:item.codigo="{ item }">
              {{ item.codigo }}
            </template>

            <template v-slot:item.cliente="{ item }">
              {{ item.cliente }}
            </template>

            <template v-slot:item.saldotitulo="{ item }">
              {{ item.saldotitulo | formataDinheiro }}
            </template>

            <template v-slot:item.tipo="{ item }">
              {{ item.tipo }}
            </template>

            <template template v-slot:expanded-item="{}">
              <td colspan="10" class="px-0 primary">
                <CreduTitulosTabela :titulos="dadosCliente" :carregando="carregando2" />
              </td>
            </template>
            <template v-slot:footer>
              <v-divider v-if="dados.total > 20" />
              <v-progress-linear indeterminate absolute :active="carregando" />
              <Paginacao :class="dados.total > 20 ? 'my-2 pb-2' : ''" :total="dados.total"
                         @atualizar="listar" :carregando="carregando" :pg="pgSelecionada" />
            </template>
          </v-data-table>

        </v-card-text>


        <v-card-actions class="pa-1 pb-3 pr-3">
          <v-spacer />
          <v-btn color="green darken-1" elevation="0" class="px-5" @click="dialogVerifica = true"
                 :disabled="dadosTodosCliente.lista.length <= 0 || carregando || carregando2">
            Baixar
            <v-icon class="ml-2">mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import mixinFilial from "../../util/mixinFilial";
import Paginacao from "../Widgets/Paginacao.vue";
import CreduTitulosTabela from "./CreduTitulosTabela.vue";

export default {
  components: { Paginacao, CreduTitulosTabela },
  name: "CreduLancamento",
  mixins: [mixinFilial],
  data: () => ({
    dialog: { status: false, dados: [], header: {} },
    dialog2: { status: false },
    alerta2: false,
    busca: {
      data: "",
      idfiliais: [],
    },
    datas: [],
    headers: [
      { text: '', value: 'data-table-select', sortable: false }, // Coluna do checkbox
      { text: 'Cód. Filial', value: 'idempresa', class: 'text-no-wrap' },
      { text: 'Cód Cliente', value: 'codigo', class: 'text-no-wrap' },
      { text: 'Cliente', value: 'cliente', class: 'text-no-wrap' },
      { text: 'Valor', value: 'saldotitulo', class: 'text-no-wrap' },
      { text: 'Tipo', value: 'tipo', class: 'text-no-wrap' },
      { text: 'Pendências', value: 'chequespendentes', class: 'text-no-wrap', sortable: false },
    ],
    carregando: false,
    buscou: false,
    carregando2: false,
    carregandoSkeleton: false,
    selectAllChecked: false,
    todos: false,
    dialogVerifica: false,
    selecionados: [], // chaves cliente+tipo selecionadas (a procedure baixa o cliente inteiro)
    selecionadosAgrupado: [],
    //selecionaTodos: [],
    dados: { lista: [], total: 0, totalcredu: 0 },
    dadosCliente: [],
    dadosTodosCliente: { lista: [] },
    v: false,
    expanded: [],
    cliente: {},
    pgSelecionada: 0,
    pagOn: false,
    anoAtual: new Date(),
  }),
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial != 6 &&
              v.idfilial != 12 &&
              v.idfilial != 13 &&
              v.idfilial != 25 &&
              v.idfilial != 28 &&
              v.idfilial != 29 &&
              v.idfilial != 33 &&
              v.idfilial != 37 &&
              v.idfilial != 39 &&
              v.idfilial != 40 &&
              v.idfilial != 42
          );
        });
      } else {
        return [];
      }
    },
    chavesClientes() {
      return [...new Set(this.dadosTodosCliente.lista.map(v => v.compositeKey))];
    },
    selectAll() {
      return this.selecionados.length > 0 && this.selecionados.length === this.chavesClientes.length;
    },
    isIndeterminate() {
      return this.selecionados.length > 0 && this.selecionados.length < this.chavesClientes.length;
    },
    titulosSelecionados() {
      return this.baixaveis(this.dadosTodosCliente.lista.filter(v => this.selecionados.includes(v.compositeKey)));
    },
    clientesComPendencia() {
      const pendentes = {};
      this.dadosTodosCliente.lista
          .filter(v => this.selecionados.includes(v.compositeKey) && !v.baixavel)
          .forEach(v => {
            if (!pendentes[v.compositeKey]) {
              pendentes[v.compositeKey] = { cliente: v.cliente, quantidade: 0 };
            }
            pendentes[v.compositeKey].quantidade++;
          });
      return Object.values(pendentes);
    },
  },
  methods: {
    toggleSelectAll(tipo) {
      if (tipo == 'CHECKBOX') {
        if (this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.busca.idfiliais = this.filiaisFiltro.map(item => item.idfilial);
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.busca.idfiliais = [];
        }
      } else {
        if (!this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.busca.idfiliais = this.filiaisFiltro.map(item => item.idfilial);
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.busca.idfiliais = [];
        }
        this.selectAllChecked = !this.selectAllChecked;
      }
    },
    toggleSelectAllCredu() {
      this.selecionados = this.selectAll ? [] : [...this.chavesClientes];
    },
    isClienteSelecionado(item) {
      return this.selecionados.includes(item.compositeKey);
    },
    toggleCliente(item) {
      const index = this.selecionados.indexOf(item.compositeKey);
      if (index === -1) {
        this.selecionados.push(item.compositeKey);
      } else {
        this.selecionados.splice(index, 1);
      }
    },
    baixaveis(lista) {
      return Array.isArray(lista) ? lista.filter(v => v.baixavel) : [];
    },
    somar(lista, campo) {
      return Array.isArray(lista) ? lista.reduce((a, v) => a + (v[campo] || 0), 0) : 0;
    },
    listar(pg) {
      if (this.busca.idfiliais.length === 0) return;
      this.buscou = true;
      this.pgSelecionada = pg;
      this.carregando = true;
      this.dados = { lista: [], total: 0, totalcredu: 0 }
      this.carregandoSkeleton = true;
      this.selecionados = [];
      this.expanded = [];
      return axios
          .post(`${this.backendUrl}credu/listar`, {
            data: this.busca.data,
            idempresa: this.busca.idfiliais.join(','),
            limit: this.pgLimit,
            offset: this.pgLimit * pg,
          })
          .then((res) => {
            this.dados.lista = res.data.lista == null ? [] : res.data.lista.map((v) => {
              const compositeKey = `${v.idempresa}-${v.codigo}-${v.tipo}`;
              return {
                ...v,
                compositeKey: compositeKey,
              };
            });
            this.dados.total = res.data.total;
            this.dados.totalcredu = res.data.totalcredu;
            this.carregando = false;
            this.carregandoSkeleton = false;
            // Após buscar os clientes, chama a função para listar os dados detalhados
            this.listarClientes();
          })
          .catch(() => {
            this.dados = { lista: [], total: 0 };
            this.carregando = false;
            this.carregandoSkeleton = false;
          });
    },
    listaClienteSelecionado(id) {
      // Busca o cliente pelo id dentro do array de clientes
      this.dadosCliente = this.dadosTodosCliente.lista.filter(cliente => cliente.compositeKey === id);
      //console.log(this.dadosTodosCliente.lista);
      // Verificação adicional para caso o cliente não seja encontrado
      if (!this.dadosCliente) {
        //console.log('Cliente não encontrado');

      } else {
        //console.log('Cliente encontrado:', this.dadosCliente);
        this.carregando = false;
        //this.carregando2 = false;
        this.carregandoSkeleton = false;
      }
    },
    listarClientes() {
      this.dadosTodosCliente = { lista: [] };
      this.carregando2 = true;
      return axios
          .post(`${this.backendUrl}credu/cliente/listar`, {
            data: this.busca.data,
            idempresa: this.busca.idfiliais.join(','),
          })
          .then((res) => {
            this.dadosTodosCliente.lista = res.data.lista == null ? [] : res.data.lista.map((v) => {
              const compositeKey = `${v.idempresa}-${v.codigo}-${v.tipo}`;
              return {
                ...v,
                compositeKey: compositeKey,
              };
            });

            this.carregando = false;
            this.carregando2 = false;
            this.carregandoSkeleton = false;
          })
          .catch(() => {
            this.dadosTodosCliente = { lista: [] };
            this.carregando = false;
            this.carregando2 = false;
            this.carregandoSkeleton = false;
          });
    },
    periodos() {
      let ano = this.anoAtual.getFullYear();

      return axios
          .post(`${this.backendUrl}credu/data/listar`, {})
          .then((res) => {
            this.datas = res.data.lista
                .filter(v => v.anoinicio >= ano - 1) // Evita valores antigos/indesejados
                .sort((a, b) => new Date(a.datainicio) - new Date(b.datainicio)) // ordena por data início
                .map((v) => ({
                  ...v,
                  name: `${v.descricao}/${v.anotermino}`,
                  value: v.datatermino.split("T")[0],
                }));
          });
    },
    baixarTitulos() {
      this.carregando = true;
      let titulosABaixar = null;
      if (this.titulosSelecionados.length > 0) {
        // um título por cliente+tipo: a procedure baixa todos os títulos/cheques devolvidos do cliente
        titulosABaixar = this.selecionados
            .map(chave => this.titulosSelecionados.find(v => v.compositeKey === chave))
            .filter(v => v)
      } else {
        this.alerta2 = true
      }
      return axios
          .post(`${this.backendUrl}credu/baixa`, {
            titulos: titulosABaixar,
          })
          .then((res) => {
            this.alerta2 = false
            this.carregando = false;
            this.dialog2.status = true
            this.dialog2.title = 'Baixa de títulos bem sucedida'
            this.dialog2.msg = 'Os títulos foram baixados com sucesso!'
            this.dialog2.icon = 'mdi-check-circle-outline'
            this.dialog2.iconColor = 'success'
            this.dialogVerifica = false;
            console.log(res.data);
            this.listar(0);
          })
          .catch(() => {
            this.dialog2.status = true
            this.dialog2.title = 'Erro'
            this.dialog2.msg = 'Não foi possível baixar os títulos!'
            this.dialog2.icon = 'mdi-alert-outline'
            this.dialog2.iconColor = 'red'
            this.dialogVerifica = false;
            this.carregando = false;
            //console.log("Erro");
            this.listar(0);
          });
    },
    verificaData(dataIni, dataFim) {
      const hoje = new Date();
      const inicio = new Date(dataIni);
      const fim = new Date(dataFim);

      // Verifica se hoje está entre as datas
      return hoje >= inicio && hoje <= fim;
    },
    // Método para filtrar o período atual
    predefineData() {
      if (this.datas.length === 0) return; // Se não houver dados, não tente fazer a busca

      const periodoAtual = this.datas.find(data =>
          this.verificaData(data.datainicio, data.datatermino)
      );

      if (periodoAtual) {
        this.busca.data = periodoAtual.datatermino.split("T")[0];
      }
    },
    rowClass(item) {
      return this.expanded.includes(item) ? 'primary white--text' : '';
    },
    handleRowClick(item) {// toggleExpand(item)
      this.corIcon = true;
      if(this.dadosTodosCliente != null) {
        if (this.expanded.includes(item)) {
          // Se o item já estiver expandido, remove-o da lista de expandidos
          this.listaClienteSelecionado(item.compositeKey);
          this.expanded = this.expanded.filter(i => i !== item);
        } else {
          // Caso contrário, define a lista de expandidos para conter apenas o item atual
          this.listaClienteSelecionado(item.compositeKey);
          this.expanded = [item];
        }
      }
    },
    async init() {
      // não seleciona a filial do usuário nem busca ao abrir: algumas filiais (ex.: 39 e 40) não estão no
      // filtro desta tela e, se viessem marcadas, não teriam como ser desmarcadas
      await this.periodos();
      await this.predefineData();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.table {
  margin: 0px 0px 10px 0px;
}

.header th {
  background-color: #CFD8DC !important;
  height: 25px !important;
}

.body td {
  height: 20px !important;
  font-size: larger;
}

.bold-text {
  font-weight: bold;
}

.title-expanded {
  font-size: 18px
}

.foot td {
  height: 20px !important;
}
</style>